/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_UndoInputs */



/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Action_UndoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const action_undo = /** @type {((inputs?: Action_UndoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_UndoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Undo")
});